import { Content } from "components/Layout";
import React, { useEffect } from "react";
import { scrollTop } from "../../utils/funciones";

const EmptyLayout = ({ children, ...restProps }) => {
  useEffect(() => {
    scrollTop();
  });

  return (
    <main className="cr-app bg-light" {...restProps}>
      <Content fluid>{children}</Content>
    </main>
  );
};

export default EmptyLayout;
